export default class ErrorData {
  flightId = null
  passengerId = null
  fieldName = null
  type = null
  itemId = null
}
